module.exports = __webpack_public_path__ + "img/Vietnam-5.e24711e8.jpg";